export const ALPHA_LABEL_TEST_IDS = {
  root: 'alpha-label',
} as const

export const AVATAR_UPLOAD_TEST_IDS = {
  root: 'avatar-upload',
} as const

export const COOKIE_BANNER_GUARD_TEST_IDS = {
  root: 'cookie-banner-guard',
} as const

export const CREATE_PROJECT_DIALOG_TEST_IDS = {
  root: 'create-project-dialog',
} as const

export const CREATE_WORKSPACE_VIEW_TEST_IDS = {
  root: 'create-workspace-view',
} as const

export const EMAIL_NOT_CONFIRMED_OVERLAY_TEST_IDS = {
  root: 'email-not-confirmed-overlay',
} as const

export const EMAIL_NOT_CONFIRMED_PAGE_TEST_IDS = {
  root: 'email-not-confirmed-page',
} as const

export const ERROR_BOUNDARY_TEST_IDS = {
  root: 'error-boundary',
} as const

export const GTM_CONSENT_BOOTSTRAP_TEST_IDS = {
  root: 'gtm-consent-bootstrap',
} as const

export const GTM_CONSENT_SYNC_TEST_IDS = {
  root: 'gtm-consent-sync',
} as const

export const HEADER_TEST_IDS = {
  root: 'header',
  projectSelector: 'project-selector',
  profileMenu: 'profile-menu',
  menuItemAvatar: 'header-menu-item-avatar',
} as const

export const HELP_DRAWER_TEST_IDS = {
  root: 'help-drawer',
  feedbackView: 'help-drawer-feedback-view',
  menuView: 'help-drawer-menu-view',
} as const

export const LAYOUT_TEST_IDS = {
  root: 'app-layout',
  sidebar: 'sidebar',
  registryDrawer: 'registry-drawer',
  sidebarAddNew: 'sidebar-add-new',
  sidebarSettingsBack: 'sidebar-settings-back',
  layoutMobileMenu: 'layout-mobile-menu',
  layoutDialogHost: 'layout-dialog-host',
  createProjectDialogContainer: 'create-project-dialog-container',
  projectInviteDialogContainer: 'project-invite-dialog-container',
  workspaceInviteDialogContainer: 'workspace-invite-dialog-container',
  layoutSidebarHost: 'layout-sidebar-host',
  layoutMobileMenuHost: 'layout-mobile-menu-host',
  layoutMobileMenuNavigationProvider: 'layout-mobile-menu-navigation-provider',
  layoutTopbarHost: 'layout-topbar-host',
  notificationDrawer: 'notification-drawer',
  gatewayStatus: 'gateway-status-indicator',
} as const

export const LOADER_TEST_IDS = {
  root: 'app-loader-overlay',
} as const

export const LOGO_TEST_IDS = {
  root: 'logo',
} as const

export const LOGOUT_CLIENT_TEST_IDS = {
  root: 'logout-client',
} as const

export const MAIN_CONTENT_HEADER_TEST_IDS = {
  root: 'main-content-header',
} as const

export const MEMBERS_INVITE_DIALOG_TEST_IDS = {
  root: 'invite-dialog',
  emailInput: 'invite-email-input',
  submit: 'invite-submit',
} as const

export const MOBILE_MENU_TEST_IDS = {
  root: 'mobile-menu',
  shell: 'mobile-menu-shell',
  provider: 'mobile-menu-provider',
  accountDrawer: 'mobile-menu-account-drawer',
  addNewDrawer: 'mobile-menu-add-new-drawer',
  appPickerDrawer: 'mobile-menu-app-picker-drawer',
  accountSection: 'mobile-menu-account-section',
  footer: 'mobile-menu-footer',
  header: 'mobile-menu-header',
  navigation: 'mobile-menu-navigation',
  projectPickerDrawer: 'mobile-menu-project-picker-drawer',
  projectsView: 'mobile-menu-projects-view',
  workspacesView: 'mobile-menu-workspaces-view',
  academyMenu: 'mobile-menu-academy',
  academyNavigation: 'mobile-menu-academy-navigation',
  academyDocumentationGroup: 'mobile-menu-academy-documentation-group',
  academyHomeNavItems: 'mobile-menu-academy-home-nav-items',
  academyQuickStartGroup: 'mobile-menu-academy-quick-start-group',
  academyCategorySection: 'mobile-menu-academy-category-section',
  academyQuickStartList: 'mobile-menu-academy-quick-start-list',
  conferenceMenu: 'mobile-menu-conference',
  gatewayMenu: 'mobile-menu-gateway',
  modulesMenu: 'mobile-menu-modules',
  portalMenu: 'mobile-menu-portal',
  visionMenu: 'mobile-menu-vision',
  visionTreeNoResults: 'mobile-menu-vision-tree-no-results',
} as const

export const MULTI_CODE_SNIPPET_TEST_IDS = {
  root: 'multi-code-snippet',
} as const

export const NO_PROJECTS_FALLBACK_TEST_IDS = {
  root: 'no-projects-fallback',
} as const

export const PORTAL_EMPTY_STATE_MEDIA_TEST_IDS = {
  root: 'portal-empty-state-media',
  playVideo: 'portal-empty-state-media-play-video',
} as const

export const NOTIFICATION_DRAWER_TEST_IDS = {
  root: 'notification-drawer',
  card: 'notification-drawer-card',
  cardIcon: 'notification-drawer-card-icon',
  filters: 'notification-drawer-filters',
  header: 'notification-drawer-header',
} as const

export const PROJECT_CREATED_SUCCESS_TEST_IDS = {
  root: 'project-created-success',
  continueButton: 'project-created-success-continue',
} as const

export const SEARCH_MODAL_TEST_IDS = {
  root: 'global-search-dialog',
  header: 'search-modal-header',
  footer: 'search-modal-footer',
  results: 'search-modal-results',
  chips: 'search-modal-chips',
  filterChip: 'search-modal-filter-chip',
  highlightedSnippet: 'search-modal-highlighted-snippet',
  lineTabs: 'search-modal-line-tabs',
  row: 'search-modal-row',
  rowBody: 'search-modal-row-body',
  rowIcon: 'search-modal-row-icon',
  rowIconCell: 'search-modal-row-icon-cell',
  section: 'search-modal-section',
} as const

export const SELECTOR_TEST_IDS = {
  root: 'selector',
} as const

export const SHARE_FEEDBACK_TEST_IDS = {
  root: 'share-feedback',
  content: 'share-feedback-content',
  sending: 'share-feedback-sending',
  success: 'share-feedback-success',
} as const

export const SIDEBAR_TEST_IDS = {
  root: 'sidebar-content',
  inviteButton: 'sidebar-invite-button',
  workspaceSelector: 'workspace-selector',
  menuItemAvatar: 'sidebar-menu-item-avatar',
} as const

export const TOAST_CONTAINER_TEST_IDS = {
  root: 'toast-container',
} as const

export const UNAUTHENTICATED_BANNER_TEST_IDS = {
  root: 'unauthenticated-banner',
} as const
